
import { useMutation, useQuery } from "@tanstack/react-query";
import { memberService } from "services/memberService";
import { IdForm, FormMemberStore, FormMemberUpdate } from "types";
import { usePermission } from "../usePermission";

export function useMember() {
    const { isAdmin } = usePermission()
    const getMembers = async (page = 1) => {
        if (isAdmin) {
            const res = await memberService.onGetList(page);
            return res;
        }
        return { data: null }
    };

    const onSearchMembers = async (q = '', page = 1) => {
        const res = await memberService.onSearch(q, page);
        return res;
    };

    const fetchData = (currentPage, isFetch) => {
        return useQuery({
            queryKey: ['members', currentPage, isFetch],
            queryFn: () => getMembers(currentPage),
            select: (data) => ({
                data: data.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }

    const fetchDataSearch = (q = '', page = 1) => {
        return useQuery({
            queryKey: ['membersSearch', q, page],
            queryFn: () => onSearchMembers(q, page),
            select: (data) => ({
                data: data.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }

    const createMember = useMutation({
        mutationFn: (formData: FormMemberStore) => memberService.store(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("createMember failed", err);
        },
    });

    const updateMember = useMutation({
        mutationFn: (formData: FormMemberUpdate) => memberService.update(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("updateMember failed", err);
        },
    });

    const delMember = useMutation({
        mutationFn: (formData: IdForm) => memberService.destroy(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("updateMember failed", err);
        },
    });

    return { fetchData, fetchDataSearch, getMembers, createMember, updateMember, delMember }
}
